import { render } from "./SessionCall.vue?vue&type=template&id=13aa0282&scoped=true"
import script from "./SessionCall.vue?vue&type=script&lang=js"
export * from "./SessionCall.vue?vue&type=script&lang=js"

import "./SessionCall.vue?vue&type=style&index=0&id=13aa0282&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13aa0282"]])

export default __exports__